import React, { useState, useEffect } from 'react';
import { SquareChartGantt, SquareClaimIcon, Mail } from 'lucide-react';
import { brandColors } from '../../utils/data';
import { addCommas, formatPercent } from '../../utils/tools';
import classNames from 'classnames';
import { ChevronLeft, FileCode } from 'lucide-react';
import { useData } from '../../hooks/useData';
import { useNavigate } from 'react-router-dom';
import ClaimEnvelope from './ClaimEnvelope';

const ClaimDetail = ({ file, claimId, onClick }) => {

  const [repriced, setRepriced] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalSavings, setTotalSavings] = useState(0);
  const [claim, setClaim] = useState(null);
  const [serviceLines, setServiceLines] = useState([]);

  const [repricedTotalClaims, setRepricedTotalClaims] = useState(0);
  const { claimOpenId, fileOpenId, filesOpen } = useData();

  const navigate = useNavigate();

  useEffect(() => {
    for(var i = 0; i < file.data.file.claims.length; i++){
      let claim = file.data.file.claims[i];
      if(claim.claimInfo.claimId === claimId){
        setClaim(claim);
      }
    }
  

  }, [claimId]);

  const handleBackClick = () => {
    navigate(`/file/${filesOpen[fileOpenId].slug}`);
   
  }

  return (
    <div className={classNames("file-envelope-claim", claimOpenId === 1 ? 'active' : '')}>

        <div className="file-detail-header">    
            <div className="file-detail-header-left">

                <button 
                    onClick={handleBackClick}
                    style={{ 
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '0.5rem',
                        borderRadius: '6px',
                        marginRight: '0.5rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        color: 'var(--text-primary)',
                        transition: 'background-color 0.2s ease',
                        alignSelf: 'flex-start'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = 'var(--bg-hover)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                    }}
                    >
                    <ChevronLeft size={24} />
                    
                </button>
                <FileCode size={24} color="#F7DF1E" />
                <p style={{ 
                    margin: 0, 
                    // fontSize: '1.5rem', 
                    // fontWeight: '600',
                    // color: 'var(--text-primary)'
                }}>
                    {file.name}
                </p>
            </div>
        </div>

        {claim ? (
            <ClaimEnvelope
                envelope={claim}
                onClick={() => {}}
                // claimIndex={claimIndex}
            />
        ):null}
      {/* <div className="envelope-header">
        <p className="envelope-title"><SquareChartGantt size={14} color={brandColors.blue} />&nbsp;Claim ID &nbsp;<b>{envelope.claimInfo?.claimId || 'N/A'}</b></p>
        
      </div>
       */}
      
      
      
     
    </div>
  );
};

export default ClaimDetail;
